import { CreateUserRequest } from "Domain/User/Dto/CreateUserRequest";
import executeRequest from "Infrastructure/WebClient";
import * as RequestTypes from "Application/RequestTypes";
import { ResetPasswordRequest } from "Domain/User/Dto/ResetPasswordRequest";
import { ForgotPasswordRequest } from "Domain/User/Dto/ForgotPasswordRequest";
import { CreateInternalUserRequest } from "Domain/User/Dto/CreateInternalUserRequest";

export function RegisterNewCreditor(createUserRequest: CreateUserRequest) {
  return executeRequest(RequestTypes.REGISTER_REQUEST, createUserRequest);
}

export function ResetUserPassword(resetPasswordRequest: ResetPasswordRequest) {
  return executeRequest(
    RequestTypes.RESET_PASSWORD,
    resetPasswordRequest
  );
}

export function ForgotUserPassword(forgotPasswordRequest: ForgotPasswordRequest) {
  return executeRequest(
    RequestTypes.FORGOT_PASSWORD,
    forgotPasswordRequest
  );
}

export function CreateInternalUser(internalUserRequest: CreateInternalUserRequest) {
  return executeRequest(
    RequestTypes.CREATE_INTERNAL_USER,
    internalUserRequest
  );
}